module.exports = __webpack_public_path__ + "img/white_hexagon_fees.140a67b2.png";